// extracted by mini-css-extract-plugin
module.exports = {"container":"managing-critical-position_container__jfLKl","not_found":"managing-critical-position_not_found__Cbpz-"};